import { User } from './AuthenticatedUser.context'
import { useUser } from './useUser'

export function useEnsuredUser(): User {
  const user = useUser()
  if (!user)
    throw new Error('Expected non-null user')
  return user
}
